import layoutMain from 'app/fuse-layouts/layout-main/LayoutMainConfig'

const FuseLayoutConfigs = {
  layoutMain,
}

export default FuseLayoutConfigs
